module.exports = __webpack_public_path__ + "static/media/5.question.a38cd686.mp4";